import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=7f5c29fb&"
import script from "./ChangePassword.ts?vue&type=script&lang=ts&"
export * from "./ChangePassword.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports